import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getBookingRequests = (clinicId,pageNo=0, pageSize=50, query)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/bookings/appt-requests?pageNo="+pageNo+"&pageSize="+pageSize+"&"+query)
}

const updateBookingRequests = (clinicId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/bookings/appt-requests/"+data?.id,data)
}

const getDoctorList = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/bookings/doctors")
}

//Doctor By Id
const getDoctorDetails = (clinicId,doctorId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId)
}
const updateDoctorDetails = (clinicId,doctorId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId,data)
}

//Get Doctor Hours
const getDoctorAvailability = (clinicId,doctorId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId+"/hours")
}

const updateDoctorAvailability = (clinicId,doctorId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId+"/hours",data)
}

//Get Custom working Hours Pagination
const getDoctorCustomWorkingHours = (clinicId,doctorId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId+"/custom-hours")
}
//Add Update Custom Working hours

const addUpdateDoctorCustomWorkingHours = (clinicId,doctorId,data)=>{
    return axios.post(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId+"/custom-hours",data)
}
const getAllAppointmentTypes = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/bookings/appt-types")
}
const deleteAppointmentTypeById = (clinicId,apptTypeId)=>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/bookings/appt-types/"+apptTypeId)
}
const addUpdateAppointmentType = (clinicId,data)=>{
    return axios.post(API_URL+"clinics/"+clinicId+"/bookings/appt-types",data)
}
//Doctor's Appointment Type
const getDoctorAppointmentTypes = (clinicId,doctorId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId+"/appt-types")
}
const addUpdateDoctorAppointmentTypes = (clinicId,doctorId,data)=>{
    return axios.post(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId+"/appt-types",data)
}
const deleteDoctorAppointmentTypes = (clinicId,doctorId,data)=>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/bookings/doctors/"+doctorId+"/appt-types",{data: data})
}
// Doctor's Custom HOurs
const getCustomHours = (clinicId, doctorId, pageNo = 0, pageSize = 5) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/custom-hours?pageNo=" + pageNo + "&pageSize=" + pageSize);
}
const addCustomHour = (clinicId, doctorId, data) => {
    return axios.post(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/custom-hours", data)
}
const deleteCustomHour = (clinicId, doctorId, customHourId) => {
//{{server_path}}/{{admin_path}}/clinics/{{eos_id}}//bookings/doctors/{{doctorId}}/custom-hours/{{customWorkingHoursId}}
    return axios.delete(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/custom-hours/" + customHourId)
}


const bookingService = {
    getBookingRequests,
    updateBookingRequests,
    getDoctorList,
    getDoctorDetails,
    getDoctorAvailability,
    getDoctorCustomWorkingHours,
    getAllAppointmentTypes,
    deleteAppointmentTypeById,
    addUpdateAppointmentType,
    getDoctorAppointmentTypes,
    addUpdateDoctorAppointmentTypes,
    deleteDoctorAppointmentTypes,
    updateDoctorDetails,
    updateDoctorAvailability,
    addUpdateDoctorCustomWorkingHours,
    getCustomHours,
    addCustomHour,
    deleteCustomHour
}

export default bookingService